module.exports = __webpack_public_path__ + "img/laravel.3e0c0059.svg";